import { useEffect, useState } from 'react';
import { getPracticeProfile } from 'api/paymentSetup';
import { PracticeProfile } from 'types/paymentSetup';

const initData: PracticeProfile = {
    practiceName: '',
    addressList: [
        {
            practiceAddress: '',
            practiceCity: '',
            practiceState: '',
            practiceZip: '',
            asMailing: false,
            isDefault: false,
            publicType: undefined,
        },
    ],
};

export const usePracticeProfile = (): [PracticeProfile, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<PracticeProfile>(initData);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getPracticeProfile();
            if (!result.error) {
                const data: PracticeProfile = {
                    ...(result?.data?.data?.providerPractice || initData),
                    firstName: result?.data?.data?.firstName || '',
                    lastName: result?.data?.data?.lastName || '',
                };
                setServiceData(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [serviceData, loading, fetchData];
};
